// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2_3YF","messages":"Chat_messages__3_xqu","dateDivider":"Chat_dateDivider__1AIAk"};